import makeStyles from '@mui/styles/makeStyles';

import {
  borderColor,
  darkGray,
  surfaceElevated,
  surfaceSecondary,
  teal900,
  textPrimary,
} from '@/theme/colors';

export const useStyles = makeStyles({
  formContent: {
    padding: '24px',
    backgroundColor: surfaceElevated,
  },
  iconContainer: {
    width: 64,
    height: 64,
    backgroundColor: '#D1FAE5',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 16px',
  },
  icon: {
    width: 32,
    height: 32,
    color: '#059669',
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
    color: textPrimary,
    textAlign: 'center',
    margin: '0 0 8px 0',
  },
  subtitle: {
    fontSize: 14,
    color: darkGray,
    textAlign: 'center',
    margin: '0 0 24px 0',
  },
  footer: {
    padding: '12px 24px',
    borderTop: `1px solid ${borderColor}`,
    backgroundColor: surfaceSecondary,
  },
  continueButton: {
    width: '100%',
    backgroundColor: teal900,
    color: 'white',
    fontSize: 14,
    fontWeight: 500,
    padding: '12px 24px',
    border: 'none',
    borderRadius: 4,
    cursor: 'pointer',
    textTransform: 'uppercase',
    '&:hover': {
      backgroundColor: '#004544',
    },
  },
});
